var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch:swipe.left",value:(_vm.onToggleMenu),expression:"onToggleMenu",arg:"swipe",modifiers:{"left":true}}],staticClass:"sidebar-container"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }